import { render, staticRenderFns } from "./projectSet.vue?vue&type=template&id=d830c376&scoped=true&"
import script from "./projectSet.vue?vue&type=script&lang=js&"
export * from "./projectSet.vue?vue&type=script&lang=js&"
import style0 from "./projectSet.vue?vue&type=style&index=0&id=d830c376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d830c376",
  null
  
)

export default component.exports